module.exports = __webpack_public_path__ + "static/media/kelly-sikkema-BjqLa-5vLeI-unsplash.8ed1530c.jpg";